import {Typography, TypographyProps} from './Typography'

export const Title = ({...props}: Omit<TypographyProps, 'variant'>) => {
    return <Typography variant="title" {...props}/>
}